// src/pages/Layout.js
import React from 'react';
import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles/styles.css"; // Keeping for compatibility, but its contents might need clearing or check

function Layout() {
    return (
        <div className="app-layout">
            <Navbar />
            <main>
                <Outlet />
            </main>
            <Footer />
        </div>
    );
}

export default Layout;
